import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const { SignInPage } = await import('@backstage/core-components');
      const { googleAuthApiRef } = await import('@backstage/core-plugin-api');

      return props => (
        <SignInPage
          {...props}
          title="Sign in to Nanovest IDP"
          align="center"
          providers={[
            'guest',
            {
              id: 'google-auth-provider',
              title: 'Google',
              message: 'Sign in with your Nanovest Google account',
              apiRef: googleAuthApiRef,
            },
          ]}
        />
      );
    },
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
